module.exports = __webpack_public_path__ + "img/personal19.bbcacc0d.jpg";